import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { CadastroConsumidorRequest, Types } from './types';

// ACTIONS
import {
	cadastroConsumidorSuccess,
	cadastroConsumidorFailure,
} from './actions';

function* cadastroConsumidorRequest(request: ReducerAction) {
	const { payload }: { payload: CadastroConsumidorRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`consumidores/${CHANNEL}/consumidores`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(cadastroConsumidorSuccess(response));
	} else {
		yield put(cadastroConsumidorFailure(response));
	}
}

export default all([
	takeLatest(Types.CADASTRO_CONSUMIDOR_REQUEST, cadastroConsumidorRequest),
]);
